var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.progressClick}},[_c('Forest',{attrs:{"totalTrees":_vm.totalTrees,"userTrees":_vm.userTrees,"open":_vm.open}}),_c('goal-progress',{attrs:{"progress":_vm.userTrees,"goal":_vm.goal,"lvl":_vm.lvl,"open":_vm.open}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }